import { render } from "./AddCollaboratorModal.vue?vue&type=template&id=dc93c1fa&scoped=true"
import script from "./AddCollaboratorModal.vue?vue&type=script&lang=js"
export * from "./AddCollaboratorModal.vue?vue&type=script&lang=js"

import "./AddCollaboratorModal.vue?vue&type=style&index=0&id=dc93c1fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dc93c1fa"

export default script